import { StyleSheet } from 'react-native';
import { widthPercentageToDP as wp, heightPercentageToDP as hp } from 'react-native-responsive-screen';

export const styles = StyleSheet.create({
  containerLarge: {
    flex: 0.5,
    flexDirection: 'row',
    alignSelf: 'flex-end',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 250,
    marginTop: 40,
    borderWidth: 1,
    borderRadius: 28,
    width: wp('50%'),
    height: hp('8%'),
  },
  containerSmall: {
    flexDirection: 'row',
    alignSelf: 'flex-end',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 10,
    borderWidth: 1,
    borderRadius: 28,
    width: 300,
    height: 50,
  },
  input: {
    backgroundColor: 'transparent',
    paddingVertical: 0,
    borderBottomWidth: 0,
    borderWidth: 0,
    borderColor: 'transparent',
    marginTop: 25,
  },
  button: {
    marginTop: 25,
    width: 25,
    height: 25,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
